import { render, staticRenderFns } from "./AlternateHSQualifierUnder4List2.vue?vue&type=template&id=5f26e68e&scoped=true&"
import script from "./AlternateHSQualifierUnder4List2.vue?vue&type=script&lang=ts&"
export * from "./AlternateHSQualifierUnder4List2.vue?vue&type=script&lang=ts&"
import style0 from "./AlternateHSQualifierUnder4List2.vue?vue&type=style&index=0&id=5f26e68e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26e68e",
  null
  
)

export default component.exports